import { useStaticQuery, graphql } from 'gatsby'

export const useCalloutQuery = () => {
  const { wp } = useStaticQuery(graphql`
    query CalloutQuery {
      wp {
        acfOptionsCommonItems {
          commonItems {
            callout {
              backgroundImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP)
                  }
                }
              }
              foregroundImage {
                localFile {
                  childImageSharp {
                    gatsbyImageData(formats: WEBP)
                  }
                }
              }
              foregroundAltText
              title
              subtitle
              calloutButtonText
            }
          }
        }
      }
    }
  `)
  return wp.acfOptionsCommonItems.commonItems.callout
}
